const styles = (theme) => ({
  dialogContent: {
    padding: 0,
  },
})

export default styles
